define('MaxaPartPicker.Collection.View', [
    'SCCollectionView',
    'MaxaPartPicker.Details.View',
    'eureka_maxapartpicker_collection.tpl',
    'jQuery'
], function (
    SCCollectionViewModule,
    MaxaPartPickerDetailsView,
    eureka_maxapartpicker_collection_tpl,
    jQuery
) {
    'use strict';

    var SCCollectionView = SCCollectionViewModule.SCCollectionView;

    function MaxaPartPickerCollectionView (options) {
        SCCollectionView.call(this, options.collection);

        this.collection = options.collection;
        //console.log("In Here", this.collection)

        this.template = eureka_maxapartpicker_collection_tpl;

    }

    MaxaPartPickerCollectionView.prototype = Object.create(SCCollectionView.prototype);
    MaxaPartPickerCollectionView.prototype.constructor = MaxaPartPickerCollectionView;

    MaxaPartPickerCollectionView.prototype.getCellViewsPerRow = function () {
        return 3
    }

    MaxaPartPickerCollectionView.prototype.getCellViewInstance = function (model) {
        //console.log("model", model)
        return new MaxaPartPickerDetailsView({
            model: model
        })
    }

    MaxaPartPickerCollectionView.prototype.getContext = function () {
        return {}
    }

    return MaxaPartPickerCollectionView
})
